import { NgModule } from '@angular/core';
import { LocalPlanService } from './local-plan.service';

@NgModule({
  providers: [LocalPlanService],
  imports: [],
})
export class LocalPlanServiceModule {}
